<template>
  <div
    :class="{
      'z-form-item': true,
      'mb-0': reset_margin,
      'mh-60': reset_margin
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      reset_margin: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss">
  .z-form-item {
    margin-bottom: 28px;
    align-items: center;
  }

  .auth-content {
    .z-form-item {
      margin-bottom: 20px;
    }
  }

  .mh-60 {
    min-height: 60px;
  }
</style>
